import React from 'react';
import { brands } from '../mock';
import { X } from 'lucide-react';

export default function BrandsMarquee() {
  // duplicate for seamless loop
  const items = [...brands, ...brands];
  return (
    <section className="py-20 md:py-24 border-y border-neutral-900">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <p className="mono text-[11px] tracking-[0.22em] text-[#ED2D5C]">// CREDITS ROLL</p>
        <h2 className="mt-4 font-display text-white text-[44px] sm:text-[64px] md:text-[84px] leading-[0.92]">
          Produced for & trusted by
        </h2>
      </div>

      <div className="mt-12 md:mt-16 overflow-hidden">
        <div className="animate-marquee flex items-center whitespace-nowrap gap-12 md:gap-20">
          {items.map((b, i) => (
            <div key={i} className="flex items-center gap-12 md:gap-20">
              <span className="font-display text-neutral-600 hover:text-white transition-colors text-[40px] md:text-[64px] tracking-tight">
                {b}
              </span>
              <X size={22} className="text-[#ED2D5C] shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
